// Development values

export const environment = {
  googleMapsApiKey: 'AIzaSyAOVYRIgupAurZup5y1PRh8Ismb1A3lLao',
  stripeApiKey: 'pk_test_51O87KxAawgYYcPfzODi6bwtDlXoTsuDQ9DGFXwCXnPYUeqn4cXmqNFscQNh0nAUdtUXxoWSg568jbv182ov4KrQF00Es7p93Nm',
  production: false,
  firebase: {
    apiKey: "AIzaSyAq8CtkhAbIMH4Ub-If0KPKFbj9Tb5iEdE",
    authDomain: "dev-rfm-cg.firebaseapp.com",
    projectId: "dev-rfm-cg",
    storageBucket: "dev-rfm-cg.firebasestorage.app",
    messagingSenderId: "525758471109",
    appId: "1:525758471109:web:6bfca47e597ef23d0449ac",
    measurementId: "G-0EXT8T2N8J"
   },
  backendUrl: ""
} 


/*  // Production values
export const environment = {
  googleMapsApiKey: 'AIzaSyAOVYRIgupAurZup5y1PRh8Ismb1A3lLao',
  stripeApiKey:
    'pk_live_51O87KxAawgYYcPfzDdZ91X85Q4PRA1hZAWYZjmZxGQoXx5XXD5YNTy7d6qytt8I8WtTiFxoYgTbraoCwEGJpDsN200jAwzJNFC',
  production: true,
  firebase: {
    apiKey: 'AIzaSyAVfjRdd5GK9yFJx8jkFHrZP5OA1YGuWUc',
    authDomain: 'rfm-osp.firebaseapp.com',
    databaseURL: 'https://rfm-osp-default-rtdb.firebaseio.com',
    projectId: 'rfm-osp',
    storageBucket: 'rfm-osp.firebasestorage.app',
    messagingSenderId: '766752602477',
    appId: '1:766752602477:web:bc5b1474ebc26dc3b78264',
    measurementId: 'G-T8SF745TF7',
  },
  backendUrl: '',
}; */